// extracted by mini-css-extract-plugin
export default {"product-instances__search":"ProductInstances_product-instances__search__XQxX4"};